export default {
  "NOTES": "नोट्स"
};